export const setItem = (key, value) => {
  try {
    const v = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, v);
  } catch (e) {
    // noop
  }
};
export const getItem = (key) => {
  try {
    const v = localStorage.getItem(key);
    if (v === null) return null;
    // Try JSON parse, else return raw
    try { return JSON.parse(v); } catch { return v; }
  } catch (e) {
    return null;
  }
};
export const removeItem = (key) => {
  try { localStorage.removeItem(key); } catch (e) {}
};
// Clear only auth-related keys to avoid nuking unrelated app data
export const clearAuth = () => {
  ['state','expires_at','authenticated','id_token'].forEach(k => {
    try { localStorage.removeItem(k); } catch (e) {}
  });
};